function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_232",
  "data-name": "Rectangle 232",
  width: 31,
  height: 31,
  transform: "translate(-1 -1.741)",
  fill: "#124795"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1276",
  "data-name": "Group 1276",
  transform: "translate(1 1.741)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_757",
  "data-name": "Path 757",
  d: "M27.664,8.433q-.65.738-1.284,1.487A12.738,12.738,0,1,1,13.557,1.8q.469-.034.937-.034a12.739,12.739,0,0,1,7.048,2.124q.555-.689,1.122-1.37a14.54,14.54,0,1,0,5,5.915",
  fill: "#124795"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_758",
  "data-name": "Path 758",
  d: "M16,2l0-.039A5.172,5.172,0,0,0,16,.945c0-.048-.031-.271-.078-.487-.06-.277-.126-.43-.2-.454-.012,0-.043-.014-.088.035a45.39,45.39,0,0,0-5.506,7.424l-.254.4s-.672-.906-1.234-1.531a10.76,10.76,0,0,0-1.922-1.7C6.7,4.592,5.615,6.031,5.615,6.031a14.9,14.9,0,0,1,2,1.938A14.374,14.374,0,0,1,9.474,10.75c.033,0,3.766-5.719,6.374-8.188A1.207,1.207,0,0,0,16,2",
  transform: "translate(14.494 2)",
  fill: "#124795"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_32",
  "data-name": "Ellipse 32",
  cx: 3.508,
  cy: 3.508,
  rx: 3.508,
  ry: 3.508,
  transform: "translate(12.325 9.284)",
  fill: "none",
  stroke: "#124795",
  strokeMiterlimit: 10,
  strokeWidth: 1.7
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_759",
  "data-name": "Path 759",
  d: "M195.1,224.655a5.483,5.483,0,0,1,10.965,0",
  transform: "translate(-184.747 -202.939)",
  fill: "none",
  stroke: "#124795",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.7
});

var SvgExamination = function SvgExamination(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExamination, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/examination.a3c8c705.svg";
export { ForwardRef as ReactComponent };